import { Card, Col, Row } from 'react-bootstrap';
import { ReportPage } from '../components/ReportPage';
import { useLoaderData } from "react-router-dom";
import { DetectionLoaderData } from "../loaders/detectionLoader";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveScatterPlotCanvas } from '@nivo/scatterplot';
import { ObbDet } from "../api/Application";

function rnd( num: number ) {
    return Math.round( num * 4 ) / 4;
}

function bucketize( values: number[] ): { bucket: string, count: number }[] {
    const counts: Record<number, number> = {};
    values.forEach( v => {
        const bucket = rnd( v );
        counts[bucket] = ( counts[bucket] || 0.0 ) + 1.0;
    } );
    const ret = Object.entries( counts )
        .sort( ( [a], [b] ) => Number( a ) - Number( b ) )
        .map( ( [bucket, count] ) => ( { bucket, count } ) );
    return ret;
}

function obbToVehicle( gsd: number, vehicle: ObbDet ) {
    return {
        length: vehicle.width  * gsd,
        width:  vehicle.height * gsd,
    };
}

export function ReportObbDet() {
    const { image, vehicles } = useLoaderData() as DetectionLoaderData;    
    const gsd    = image.pixelWidth; //100cm
    const lenLim = 700;
    const widLim = 450;
    const conv = obbToVehicle.bind( undefined, gsd );
    const vs = vehicles.map( conv );
                    //    .filter( v => v.width  < widLim )
                    //    .filter( v => v.length < lenLim );

    const widthData  = bucketize( vs.map( v => v.width  ) );
    const lengthData = bucketize( vs.map( v => v.length ) );
    return <ReportPage>
        <Row>
            <Col md={6}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <div className="fs-4">Length Distribution (1px Buckets)</div>
                        <div style={{ height: '300px' }}>
                            <ResponsiveBar
                                data={lengthData}
                                keys={['count']}
                                indexBy="bucket"
                                margin={{ top: 40, right: 20, bottom: 60, left: 60 }}
                                padding={0.2}
                                colors={{ scheme: 'category10' }}
                                axisBottom={{
                                    legend:         'Length (px)',
                                    legendPosition: 'middle',
                                    legendOffset:   40,
                                    tickRotation:   -90,
                                    ticksPosition: "before",
                                    format: ( value ) => {
                                        const start = Number( value );
                                        const end = start + 30; // your bucket size
                                        return `${start}`;
                                    },
                                }}
                                axisLeft={{
                                    legend:         'Count',
                                    legendPosition: 'middle',
                                    legendOffset:   -50
                                }}
                                // labelSkipWidth={12}
                                // labelSkipHeight={12}
                                labelTextColor={{ from: 'color', modifiers: [['brighter', 3.6]] }}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={6}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h5>Width Distribution (1px Buckets)</h5>
                        <div style={{ height: '300px' }}>
                            <ResponsiveBar
                                data={widthData}
                                keys={['count']}
                                indexBy="bucket"
                                margin={{ top: 40, right: 20, bottom: 50, left: 60 }}
                                padding={0.2}
                                colors={{ scheme: 'set2' }}
                                axisBottom={{
                                    legend: 'Width (px)',
                                    legendPosition: 'middle',
                                    legendOffset: 40
                                }}
                                axisLeft={{
                                    legend: 'Count',
                                    legendPosition: 'middle',
                                    legendOffset: -50
                                }}
                                labelSkipWidth={12}
                                labelSkipHeight={12}
                                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        <Row className="mt-4">
            <Col md={12}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h5>Vehicle Width vs Height</h5>
                        <div style={{ height: '400px' }}>
                            <ResponsiveScatterPlotCanvas
                                data={[
                                    {
                                        id: 'Vehicles',
                                        data: vs.map( v => ( {
                                            x: v.width,
                                            y: v.length,
                                        } ) ),
                                    },
                                ]}
                                margin={{ top: 50, right: 90, bottom: 70, left: 90 }}
                                xScale={{ type: 'linear', min: 'auto', max: 'auto' }}
                                yScale={{ type: 'linear', min: 'auto', max: 'auto' }}
                                axisBottom={{
                                    legend: 'Width (px)',
                                    legendPosition: 'middle',
                                    legendOffset: 46,
                                    tickRotation: -45,
                                }}
                                axisLeft={{
                                    legend: 'Height (px)',
                                    legendPosition: 'middle',
                                    legendOffset: -60,
                                }}
                                colors={{ scheme: 'set1' }}
                                // blendMode="multiply"
                                nodeSize={8}
                                // nodeColor={{ from: 'color' }}
                                // nodeBorderWidth={1}
                                // nodeBorderColor={{ from: 'color', modifiers: [['darker', 0.8]] }}
                                useMesh={true}
                                legends={[
                                    {
                                        anchor: 'bottom-right',
                                        direction: 'column',
                                        translateX: 130,
                                        itemWidth: 100,
                                        itemHeight: 12,
                                        symbolSize: 12,
                                        symbolShape: 'circle',
                                    },
                                ]}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </ReportPage>;
}